<template>
  <div class="form-group">
    <label v-if="label" class="form-label" :for="id">{{ label }}</label>
    <div class="input-group">
      <input class="form-control" :id="id" :type="type" :placeholder="placeholder" :value="modelValue"
        v-bind="{ ...$attrs, class: null }" @input="$emit('update:modelValue', $event.target.value)">
      <div class="input-group-append">
        <div class="input-group-text">
          <span class="fas fa-calendar-alt"></span>
        </div>
      </div>
    </div>
    <span v-if="error" style="color:#dc3545; font-size:80%">{{ error }}</span>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import "admin-lte/plugins/daterangepicker/daterangepicker.js"
import moment from 'moment'
moment.locale('id')

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `datescope-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
    placeholder: String,
    class: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
  mounted() {
    let today = moment(new Date()).subtract(1, 'd').format("DD-MM-YYYY");
    let endday = moment(new Date()).add(30, 'd').format("DD-MM-YYYY");

    this.tanggal = $(this.$el)
      .find('input')
      .daterangepicker({
        singleDatePicker: true,
        autoApply: true,
        startDate: today,
        endDate: today,
        endDate: today,
        minDate: today,
        maxDate: endday,
        locale: {
          format: 'DD-MM-YYYY',
        }
      })
      .on('apply.daterangepicker', ev => {
        this.$emit('update:modelValue', this.tanggal.val());
      });
  }
}
</script>

<style>
@import 'admin-lte/plugins/daterangepicker/daterangepicker.css';
</style>